var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoPlayer",staticClass:"fp-slim is-splash flowplayer d-block",staticStyle:{"padding-top":"56.25%"},style:(_vm.posterImg),attrs:{"id":"player","data-share":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }